import { Box, Container, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React from 'react'
import { Component } from 'react'
import Constantes from '../php/Constantes';
import logo from './5k.jpeg';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

let desc = '';
class Ini extends Component {
    constructor(props){
        super(props);
        this.state = {
            circulares: [],
            hayDatos: '',

            consultaEspecifica: false,
            datoEspecifico: {},
        }

        this.manejarConsultaCircular = this.manejarConsultaCircular.bind(this);
        this.manejarCerrarConsulta = this.manejarCerrarConsulta.bind(this);
    }

    async componentDidMount(){
        const circu = await fetch(`${Constantes.RUTA_API}/obtener_circularesActivas.php`);
        const datoCirculares = await circu.json();
        this.setState({
            hayDatos: datoCirculares[0],
            circulares: datoCirculares[1],
        });
    }
    
    redirectToLink = () => {
        // Redirigir a la URL cuando se hace clic en el botón
        window.open('https://chlaep.org.uy/programa-nacional-de-control-de-tuberculosis/5km-contra-la-tuberculosis/');
        //window.location.href = 'https://chlaep.org.uy/programa-nacional-de-control-de-tuberculosis/recertificacion-en-vacunacion/';
      };

    render(){
        return (
            <>
                <Container>
                    <br/>
                    <p style={{textAlign: 'left'}}><strong>IMPORTANTE:</strong></p>
                    <p style={{textAlign: 'center'}}>Se recuerda a quienes tengan licencia o antiguedad del ejercicio 2024, que el plazo para usufructuar las mismas vence, indefectiblemente el 31/12/2026.</p>
                    {/*<br/>
                    {this.state.consultaEspecifica ? null : <h3>Novedades</h3>}
                    <br/>
                    {(this.state.hayDatos === 'ok') && (!this.state.consultaEspecifica)
                    ?
                        <Container>
                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.circulares.map((name) => (
                                        <StyledTableRow key={name.idCirculares}>
                                            <StyledTableCell>{name.titulo}</StyledTableCell>
                                            <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaCircular(name)}>Consultar</button></StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Container>
                    :
                        null
                    }

                    {this.state.consultaEspecifica
                    ?
                        <Container>
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <img src={this.state.datoEspecifico.archivoBase} alt="" style={{ width: '100%'}}/>
                                </Grid>
                            </Box>
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarCerrarConsulta}>Cerrar</button>
                        </Container>
                    :
                        null
                    }*/}
                </Container>
            </>
        )
    }

    manejarConsultaCircular(dato){
        this.setState({
            consultaEspecifica: true,
            datoEspecifico: dato,
        })
    }

    manejarCerrarConsulta(e){
        e.preventDefault();
        this.setState({
            consultaEspecifica: false,
            datoEspecifico: {},
        })
    }
}

export default Ini